import { createContext, useContext, useState } from "react";
import {
  po_default_value_v2,
  PurchaseOrderModelV2,
} from "../model/purchase_order_model";
import { default_mail_detail } from "../../accounts/models/party_model";
import { Project } from "../../inventory/models/project_model";

interface PurchaseOrderContextType {
  defaultProject: Project | null;
  setDefaultProject: React.Dispatch<React.SetStateAction<Project | null>>;
  purchaseOrder: PurchaseOrderModelV2;
  setPurchaseOrder: React.Dispatch<React.SetStateAction<PurchaseOrderModelV2>>;
}

const PurchaseOrderContext = createContext<PurchaseOrderContextType | null>(
  null,
);

export const PurchaseOrderProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [purchaseOrder, setPurchaseOrder] = useState<PurchaseOrderModelV2>({
    ...po_default_value_v2,
    shipping_profile: {
      ...default_mail_detail,
    },
    payment_term:
      "Payment shall be made within 30 days of receipt of the invoice and delivery of goods, subject to quality approval. 20% of invoice value will be given as advance payment.",
    ship_term:
      "Delivery shall be completed within 10 days of the purchase order.",
  });

  const [defaultProject, setDefaultProject] = useState<Project | null>(null);

  return (
    <PurchaseOrderContext.Provider
      value={{
        purchaseOrder,
        defaultProject,
        setPurchaseOrder,
        setDefaultProject,
      }}
    >
      {children}
    </PurchaseOrderContext.Provider>
  );
};

export const usePurchaseOrder = () => {
  const context = useContext(PurchaseOrderContext);
  if (!context) {
    throw new Error(
      "usePurchaseOrder must be used within a PurchaseOrderProvider",
    );
  }
  return context;
};

export default PurchaseOrderProvider;
